import { useState, useRef, useEffect } from 'react';
import Select from "react-select";
import { FiCalendar } from "react-icons/fi";
import useEmployeeDetails from '../hooks/useEmployeeDetails';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import moment from "moment";


export default function RequestForLeave() {
  const { id, employeeToken } = useEmployeeDetails();
  const API_URL = process.env.REACT_APP_BASE_URL;
  // const navigate = useNavigate();

  const [formData, setFormData] = useState({
    emp: id,
    leave_type: "",
    start_date: "",
    end_date: "",
    reason: ""
  });

  const [leaveStats, setLeaveStats] = useState({ total: 0, pending: 0, approved: 0, rejected: 0 });
  console.log("leaves",leaveStats);
  

  const getDuration = (start, end) => {
    const startDate = moment(start);
    const endDate = moment(end);
    return endDate.diff(startDate, "days") + 1;
  };

  // const duration =
  //   formData.start_date && formData.end_date
  //     ? getDuration(formData.start_date, formData.end_date)
  //     : '';

  const [loading, setLoading] = useState(false);

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const leaveOptions = [
    { value: 'casual_leave', label: "Casual Leave" },
    { value: 'sick_leave', label: "Sick Leave" },
    { value: 'earned_leave', label: "Paid Leave" },
    { value: 'maternity_leave', label: "Maternity Leave" },
    { value: 'paternity_leave', label: "Paternity Leave" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/staff_request_leave`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${employeeToken}`,
        },
      });

      // Show the message from the response (always)
      // const message = response.data?.message || "No message returned from server.";
      toast.success("Success message", {
        position: "top-center",     // ✅ good
        autoClose: 3000,            // ✅ good
        hideProgressBar: false,     // ✅ good
        closeOnClick: true,         // ✅ good
        pauseOnHover: true,         // ✅ good
        draggable: true,            // ✅ good
      });


      // Reset the form if leaveRequest exists
      if (response.data?.leaveRequest) {
        setFormData({ emp: id, leave_type: "", start_date: "", end_date: "", reason: "" });
        // Optionally: fetchTeamLeaves();
      }

    } catch (err) {
      const errorMessage = err.response?.data?.message || "Something went wrong.";
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLeaveStats({ total: 12, pending: 3, approved: 6, rejected: 3 });
  }, []);

  return (
    <div className=" max-w-4xl mx-auto">
      {/* Cards */}
      {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[
          { label: "Total", count: leaveStats.total, color: "bg-blue-100 text-blue-800" },
          { label: "Pending", count: leaveStats.pending, color: "bg-yellow-100 text-yellow-800" },
          { label: "Approved", count: leaveStats.approved, color: "bg-green-100 text-green-800" },
          { label: "Rejected", count: leaveStats.rejected, color: "bg-red-100 text-red-800" },
        ].map((item, i) => (
          <div key={i} className={`rounded-xl p-4 shadow ${item.color}`}>
            <p className="font-bold text-xl">{item.count}</p>
            <p className="text-xs">{item.label} Leaves</p>
          </div>
        ))}
      </div> */}

      {/* Leave Request Form */}
      <div className="px-6">
        <h2 className="text-md text-center font-semibold">Request for Leave</h2>

        {/* Leave Type */}
        <div className="mb-4">
          <Select
            placeholder="Select Leave Type"
            options={leaveOptions}
            value={leaveOptions.find(opt => opt.value === formData.leave_type)}
            onChange={(selected) =>
              setFormData({ ...formData, leave_type: selected?.value })
            }
          />
        </div>

        {/* Dates */}
        {/* Dates Selection */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div
            className="bg-gray-50 flex justify-between items-center p-3 rounded-lg border cursor-pointer"
            onClick={() => fromDateRef.current?.showPicker()}
          >
            <p>{formData.start_date || "Start Date"}</p>
            <FiCalendar />
            <input
              type="date"
              ref={fromDateRef}
              className="hidden"
              onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
            />
          </div>

          <div
            className="bg-gray-50 flex justify-between items-center p-3 rounded-lg border cursor-pointer"
            onClick={() => toDateRef.current?.showPicker()}
          >
            <p>{formData.end_date || "End Date"}</p>
            <FiCalendar />
            <input
              type="date"
              ref={toDateRef}
              className="hidden"
              min={formData.start_date}
              value={formData.end_date}
              onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
            />
          </div>
        </div>

        {/* Duration Field */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Duration</label>
          <input
            type="text"
            value={
              formData.start_date && formData.end_date
                ? `${getDuration(formData.start_date, formData.end_date)} day${getDuration(formData.start_date, formData.end_date) > 1 ? 's' : ''
                }`
                : ''
            }
            readOnly
            className={`w-full bg-gray-100 border rounded-lg p-3 text-gray-600 ${formData.start_date && formData.end_date ? '' : 'italic text-gray-400'
              }`}
          />
        </div>



        {/* Reason */}
        <textarea
          className="w-full bg-gray-50 rounded-lg p-3 border h-20 mb-4"
          placeholder="Reason for Leave"
          value={formData.reason}
          onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
        />

        {/* Submit */}
        <button
          className="w-full bg-green-700 text-white py-3 rounded-lg hover:bg-green-800 transition disabled:opacity-50 uppercase"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
